export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            关于我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            了解51动漫官网背后的故事与使命
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/70 p-8 md:p-12">
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
              <div className="flex-shrink-0">
                <div className="w-24 h-24 md:w-32 md:h-32 rounded-2xl bg-primary-100/70 flex items-center justify-center">
                  <i className="ri-movie-2-line text-4xl md:text-5xl text-primary-500"></i>
                </div>
              </div>

              <div className="flex-1 text-center lg:text-left">
                <h3 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4">
                  51动漫官网 — 国产动漫爱好者的精神家园
                </h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  51动漫官网创立于对国产动漫的热爱与坚持。作为连接51动漫网与51动漫网站的桥梁，我们致力于为广大动漫爱好者提供一个集资源聚合、内容导航、资讯速递于一体的综合性动漫平台入口。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  从创站之初寥寥数十部收录作品，到如今涵盖超过3000部国产动漫资源，51动漫主页见证了国漫从蹒跚起步到蓬勃发展的全过程。我们坚信国产动漫拥有无限可能，也愿意持续为动漫爱好者提供最优质的观看入口服务。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  51动漫官网始终秉持"快速、安全、全面"的运营理念，每日更新番剧进度，追踪行业动态，致力于打造国产动漫领域最具影响力的官方导航平台。无论你是资深漫迷还是刚刚入门的新观众，51动漫都欢迎你的到来。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}